/**
 * The business identity on customer-facing screens. The server sends it
 * (`company` on /api/health, the portal, public invoices and bids) from
 * Settings → Your business; these defaults only cover a screen that has no
 * server data yet (a dead portal link, the login page before /health answers).
 */
export interface Company { name: string; phone: string; phone_raw: string; email: string; address: string }

export const DEFAULT_COMPANY: Company = {
  name: 'Keep Austin Mowed', phone: '(512) 888-3417', phone_raw: '+15128883417', email: 'Michael@kamtx.com', address: '',
};

export function companyOf(data: any): Company {
  const c = data?.company;
  return c && c.phone ? { ...DEFAULT_COMPANY, ...c } : DEFAULT_COMPANY;
}
